import { render, staticRenderFns } from "./adminRoomFeeList.vue?vue&type=template&id=2a001a08&scoped=true"
import script from "./adminRoomFeeList.vue?vue&type=script&lang=js"
export * from "./adminRoomFeeList.vue?vue&type=script&lang=js"
import style0 from "./adminRoomFeeList.vue?vue&type=style&index=0&id=2a001a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a001a08",
  null
  
)

export default component.exports